import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'httpStatus',
})
export class HttpStatusPipe implements PipeTransform {
  transform(status: number): string {
    if (status >= 200 && status < 300) {
      return 'bg-success';
    } 
      return 'bg-error';
    
  }
}
